<div class="container" id="add-api-key-managed-container">
  @if (isDataLoading) {
  <div class="ph-item w-full loader-body-item m-0 p-0 border-0">
    <div class="ph-col-12 p-0 pt-6">
      <div class="ph-row">
        <div class="ph-col-4 h-[10px]"></div>
        <div class="ph-col-6 empty"></div>
        <div class="ph-col-2 h-[10px]"></div>
      </div>
    </div>
  </div>
  } @if (!isDataLoading) {
  <mat-dialog-content class="mat-dialog-content">
    <mat-accordion class="prevent-click" [@.disabled]="true">
      <mat-expansion-panel
        hideToggle
        [disabled]="true"
        [expanded]="true"
        class="parametersPanel"
        style="
          border-bottom-right-radius: 0px;
          border-bottom-left-radius: 0px;
          border-top-right-radius: 0px;
          border-top-left-radius: 0px;
          box-shadow: none;
        "
      >
        <mat-expansion-panel-header class="disable_ripple" style="height: 32px !important">
          <mat-panel-title>
            <div class="header-section">
              <p class="app__text--overflow whitespace-nowrap w-[70%] text-[#010b18]" appTooltip [toolTipText]="'MX (Financial Data Aggregator)'" (click)="$event.stopPropagation()">MX (Financial Data Aggregator)</p>
              @if (mode != 'view' && allowEditPermission) {
              <button
                style="position: relative; left: 12px"
                class="add-item-button cursor-pointer"
                (click)="$event.stopPropagation(); editDataFeedDate()"
              >
                <span style="color: #25508e; font-size: 16px; position: relative; top: 2px; left: 8px" class="material-icons">settings</span>
                <span style="position: relative; left: 8px"> Manage </span>
              </button>
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (selectedFileList.length == 0) {
        <div
          (click)="$event.stopPropagation()"
          class="app__centered-item app__solid--border flex-row text-center h-[90px] border-[#d3dce8] rounded-lg mt-3 mb-1 mx-[-20px] hover:cursor-pointer"
          style="background: linear-gradient(0deg, #ffffff, #ffffff), linear-gradient(0deg, #d3dce8, #d3dce8)"
        >
          <img src="assets/images/zero-mx-data-big.svg" width="54px" height="48px" />
          <span
            [matTooltip]="
              'By securely connecting to your financial institution, 
            we can keep this template up to date automatically for you.'
            "
            class="app__form--attribute--title font-semibold text-[#18191C] text-[12px] ml-2"
          >
            No <span class="font-bold text-[#25508E]"> Live Data Feeds </span> to show
            <mat-icon style="position: relative; top: 4px; font-size: 16px; height: 16px; width: 16px; font-weight: 700">info_outlined</mat-icon>
          </span>
        </div>
        } @if (selectedFileList.length) {
        <div class="folder-view__association-files" style="margin: 9px -24px 0 -24px !important">
          <div class="association-files-table flex fl-col width-100per">
            <div class="width-100per">
              @for (subLink of selectedFileList; track subLink; let i = $index) {
              <div class="association-files-table__body width-100per" style="background: #ffffff; overflow: hidden">
                <div style="display: flex; justify-content: space-between">
                  <div
                    class="body-card flex"
                    style="padding: 12px 21px 12px 15px !important; width: 100%; border-radius: 5px; justify-content: space-between"
                  >
                    <div class="test-zeropostion">
                      <div style="display: flex" class="mrr-10px" matTooltip="{{ subLink?.form_name ? subLink?.form_name : subLink?.name }}">
                        @if (subLink.vault_form_id && subLink.profile_image_url) {
                        <div class="form-image-container">
                          <img [src]="subLink.profile_image_url" alt="" />
                        </div>
                        } @if (!subLink.profile_image_url) {
                        <div class="form-image-container">
                          <mat-icon style="font-size: 19px; padding: 4px 2px; color: #25508e">check_circle</mat-icon>
                        </div>
                        }
                        <p class="name-title text-truncate" style="font-weight: normal !important; line-height: 36px !important">
                          {{ subLink?.form_name?.slice(0, 20) | titlecase }}
                          {{ subLink?.name?.slice(0, 20) | titlecase }}
                          {{ subLink?.form_name?.length > 20 || subLink?.name?.length > 20 ? '...' : '' }}
                        </p>
                      </div>
                    </div>
                    @if (subLink.connection_status === 'CONNECTED') {
                    <button
                      (click)="$event.stopPropagation(); editDataFeedDate()"
                      class="cursor-pointer"
                      style="background: #e2f9e4; border-radius: 4px; height: 24px; padding: 4px; width: 24px"
                    >
                      <span class="material-icons" style="font-size: 16px; color: #59ab62">link</span>
                    </button>
                    } @if (subLink.connection_status && subLink.connection_status !== 'CONNECTED') {
                    <div matTooltip="Disconnected">
                      <img src="../../../../../../assets/images/account-no-link.svg" />
                    </div>
                    }
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        }
      </mat-expansion-panel>
    </mat-accordion>
    <!-- <div>
        <div *ngIf="isRemoveEditSaveSharing" class="mobile-div">
          <div class="width-100per" *ngIf="sharedData && sharedData.length; else noData">
            <div
              class="association-files-table__body width-100per"
              style="border-radius: 4px; border: 1px solid rgba(37, 80, 142, 0.2); background: #ffffff; height: 54px; margin-bottom: 12px"
              *ngFor="let file of sharedData; let i = index"
              >
              <div class="body-card flex" style="padding: 3px 15px !important; border-radius: 5px; justify-content: space-between; height: 54px">
                <div>
                  <p class="asso-titl" style="margin-bottom: 6px" matTooltip="{{ file.form_name }}">{{ file.form_name | titlecase }}</p>
                  <p class="associate-title">
                    <span class="material-icons" [class]="checkAccessibility(file.share_date)"> fiber_manual_record </span>
                    {{ checkAccessibilityTag(file.share_date) }}
                    <span *ngIf="checkAccessibilityTag(file.share_date) == 'Accessible on '">&nbsp;{{ file.share_date | date }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <ng-template #noData>
            <div style="display: flex; flex-direction: column" *ngIf="!isRemoveEditSaveSharing">
              <img src="assets/images/empty-link.svg" style="margin: 36px auto 12px auto" />
              <p class="title-zerostate-text">There are no other files linked to this file.</p>
            </div>
          </ng-template>
        </div>
      </div> -->
  </mat-dialog-content>
  }
</div>
